module.exports = __webpack_public_path__ + "static/enterprise-meerkats-57371c5bee3c5d2f2e28cfbbe0177ece.svg";